import { Checkbox } from "primereact/checkbox";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { useDispatch, useSelector } from "react-redux";
import { setDynamicSelectedValue } from "../../redux/dynamicFieldSlice";
import { useTranslation } from "react-i18next";

export const DynamicInputField = ({ metaData }) => {

    const { t, i18n } = useTranslation();
    const selectedLanguage = i18n.language;
    const dispatch = useDispatch();
    const { possibleValues, dynamicKey, placeholder, type, label, labelNep } = metaData;

    const value = useSelector(state => (state.dynamicFieldDetails.allDynamicField[dynamicKey] || {}).value);

    console.log('RadioButtonWrapper', dynamicKey, value);
    let input;

    if (type === 'radio' || type === 'boolean') {
        input = <RadioButtonWrapper possibleValues={possibleValues} inputKey={dynamicKey} value={value} onChange={e => dispatch(setDynamicSelectedValue({ dynamicKey, value: e.target.value }))} />;
    } else if (type === 'checkbox') {
        input = <CheckboxWrapper possibleValues={possibleValues} inputKey={dynamicKey} value={value} onChange={e => dispatch(setDynamicSelectedValue({ dynamicKey, value: e.value }))} />;
    } else if (type === 'dropDown') {
        input = <Dropdown
            inputKey={dynamicKey}
            value={value}
            onChange={e => {
                // alert(e.target.value);
                dispatch(setDynamicSelectedValue({ dynamicKey, value: e.target.value }));
            }}
            options={possibleValues}
            placeholder={placeholder || label} />;
    } else {
        input = <InputText name={dynamicKey} value={value} type={type} placeholder={placeholder} onChange={e => dispatch(setDynamicSelectedValue({ dynamicKey, value: e.target.value }))} />;
    }

    return (
        <div className="p-field p-col-12 p-md-12 stick-left stick-right">
            <label className="p-col-12 p-md-12">{selectedLanguage === 'np' ? labelNep : label}{metaData.mandatory ? '*' : ''}</label>
            {input}
            {metaData.errorDesc && <span style={{ color: "red" }}>{metaData.errorDesc}</span>}
        </div>
    );
}

const RadioButtonWrapper = (props) => {
    const { possibleValues, inputKey, value, onChange } = props;

    console.log('RadioButtonWrapper', value);

    return (
        <div className="p-field-radiobutton p-col-12 p-md-12 ">
            {(possibleValues || ["Yes", "No"]).map(pvalue => (
                <>
                    <RadioButton
                        name={inputKey}
                        inputId={inputKey + pvalue}
                        value={pvalue}
                        onChange={onChange}
                        checked={value === pvalue} />
                    <label className="p-mr-5">{pvalue}</label>
                </>))}
        </div>)
};


const CheckboxWrapper = (props) => {
    const { possibleValues, inputKey, value, onChange } = props;

    return (
        <div className="p-grid p-col-12">
            {(possibleValues).map(pvalue => (
                <div className="p-field-checkbox p-col-12 p-md-2 ">
                    <Checkbox
                        name={inputKey}
                        inputId={inputKey + pvalue}
                        value={pvalue}
                        onChange={onChange}
                        checked={pvalue === value} />
                    <label>{pvalue}</label>
                </div>))}
        </div>)
};